'use strict';

/* eslint no-undef: "off" */
/**
 * open app
 */
define('openApp',['jquery', 'busEvent'], function ($, busEvent) {
  return {
    template: '\n      <div class="open-app" v-if="showOpenApp">\n        <div class="close">\n          <img class="close-img" :src="require.toUrl(\'images/openapp_close.png\')" @click.prevent="close()"/>\n        </div>\n        <div class="xpark-logo">\n          <img :src="require.toUrl(\'images/openapp_xpark.png\')" />\n        </div>\n        <div class="content">\n          <img :src="require.toUrl(\'images/openapp_text.png\')" />\n          <img :src="require.toUrl(\'images/openapp_desc.png\')" />\n        </div>\n        <div class="open-btn">\n          <div @click.prevent="openApp()">OPEN</div>\n        </div>\n      </div>\n    ',
    data: function data() {
      return {
        link: commonDataJSON.mob_link || '',
        showOpenApp: true
      };
    },
    mounted: function mounted() {
      this.init();
    },

    methods: {
      init: function init() {
        var _this = this;

        var params = new URL(document.location).searchParams;
        if (params.has("isShowHeaderAds")) {
          if (params.get("isShowHeaderAds") == "false") {
            $('.close-img').trigger('click');
            setTimeout(function () {
              busEvent.$emit('closeOpenApp');
            }, 100);
            return;
          }
        }
        busEvent.$on('showSearchEvent', function () {
          _this.showOpenApp = false;
        });
        busEvent.$on('closeSearchEvent', function () {
          _this.showOpenApp = true;
        });
        var str = navigator.userAgent;
        var isApp = str.indexOf('h5xparkwb') !== -1;
        if (isApp) {
          $('.close-img').trigger('click');
          setTimeout(function () {
            busEvent.$emit('closeOpenApp');
          }, 100);
        }
      },
      close: function close() {
        $('.open-app').hide();
        busEvent.$emit('closeOpenApp');
      },
      openApp: function openApp() {
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          this.link.replace('com.infinix.xpark', 'com.infinix.xpark.ios');
          window.location.href = this.link;
        } else {
          window.location.href = this.link;
        }
      }
    }
  };
});
